import React from "react";
import { Mail, ShieldCheck, Clock, Sparkles } from "lucide-react";
import DoctorHeader from "./DoctorHeader";
import DoctorFooter from "./DoctorFooter";

const DoctorVerification = () => {
  const email = "cjfrancisf@gmail.com";

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-white to-[#F7F8FD]">
      <DoctorHeader />

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-2xl w-full bg-white rounded-3xl shadow-xl border border-gray-100 p-8 text-center relative overflow-hidden">

          {/* Glow */}
          <div className="absolute w-[200px] h-[200px] bg-[#25DAC5]/20 blur-3xl top-[-80px] right-[-80px]" />

          {/* ICON */}
          <div className="flex justify-center mb-5">
            <div className="bg-[#25DAC5]/10 p-4 rounded-full">
              <ShieldCheck className="text-[#25DAC5]" size={32} />
            </div>
          </div>

          {/* TITLE */}
          <h1 className="text-2xl font-bold text-[#1E0E62] mb-3">
            You’re Early — That’s a Good Thing 🚀
          </h1>

          {/* SUBTEXT */}
          <p className="text-[#1E0E62]/70 text-sm leading-relaxed max-w-md mx-auto">
            Your doctor account has been successfully submitted and is currently
            under review.
          </p>

          {/* STATUS CARD */}
          <div className="mt-6 bg-[#F7F8F0] rounded-xl p-5 text-left space-y-4">

            <div className="flex items-start gap-3">
              <Sparkles className="text-[#25DAC5]" size={18} />
              <p className="text-sm text-[#1E0E62]/80">
                You are among the first doctors onboarding onto ZaviraMed
              </p>
            </div>

            <div className="flex items-start gap-3">
              <Clock className="text-[#25DAC5]" size={18} />
              <p className="text-sm text-[#1E0E62]/80">
                We are currently onboarding patients to ensure steady demand
              </p>
            </div>

            <div className="flex items-start gap-3">
              <ShieldCheck className="text-[#25DAC5]" size={18} />
              <p className="text-sm text-[#1E0E62]/80">
                You will be prioritized once doctor access opens
              </p>
            </div>
          </div>

          {/* DIVIDER */}
          <div className="my-6 border-t border-gray-100" />

          {/* EXPECTATION */}
          <p className="text-sm text-[#1E0E62]/70 leading-relaxed">
            As soon as onboarding opens, you’ll receive an email with full access
            to your dashboard and patient consultations.
          </p>

          {/* SUPPORT */}
          <div className="mt-6">
            <a
              href={`mailto:${email}`}
              className="inline-flex items-center gap-2 bg-[#25DAC5] hover:bg-[#1E0E62] text-white px-6 py-3 rounded-full text-sm font-semibold shadow transition"
            >
              <Mail size={16} />
              Contact Support
            </a>
          </div>

          {/* FOOT NOTE */}
          <p className="text-xs text-[#1E0E62]/50 mt-6">
            You’ll be notified immediately when access is granted
          </p>
        </div>
      </main>

    </div>
  );
};

export default DoctorVerification;